import { AlertService } from './../../../../widgets/entry-components/alert/services/alert.service';
import {
  ProfessionalDataComponent
} from './../../../../widgets/entry-components/modal/components/professional-data/professional-data.component';
import { TelecomAddComponent } from './../../../../widgets/entry-components/modal/components/telecom-add/telecom-add.component';
import { GenderComponent } from './../../../../widgets/entry-components/modal/components/gender/gender.component';
import { NameComponent } from './../../../../widgets/entry-components/modal/components/name/name.component';
import { ModalService } from './../../../../widgets/entry-components/modal/services/modal.service';
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { IPractitioner } from '@ahryman40k/ts-fhir-types/lib/R4';
import { AssociativeArray } from '../../../login/shared/ass-array.model';

@Component({
  selector: 'inc-practitioner-info',
  templateUrl: './practitioner-info.component.html',
  styleUrls: ['./practitioner-info.component.scss'],
})
export class PractitionerInfoComponent implements OnInit {
  modals: AssociativeArray = {
    name: () => NameComponent,
    gender: () => GenderComponent,
    telecom: () => TelecomAddComponent,
    qualification: () => ProfessionalDataComponent
  };

  @Input() practitioner: IPractitioner;
  @Input() role: string;
  @Output() callUpdatePractitioner = new EventEmitter<{ practitioner: IPractitioner, componentName: string }>();

  constructor(private modalService: ModalService, private alertService: AlertService) { }

  ngOnInit() {
  }

  presentModal(componentName: string, param?: any) {
    this.modalService.presentModal(this.modals[componentName](), { parameter: param }).then(modal => {
      modal.onDidDismiss().then(detail => {
        if (detail.data) {
          let practitioner: IPractitioner = Object.assign({}, this.practitioner);
          practitioner = this.modalRespHandler(practitioner, componentName, detail);
          this.callUpdatePractitioner.emit({ practitioner, componentName });
        }
      });
    });
  }

  modalRespHandler(prac: IPractitioner, componentName: string, detail: any): IPractitioner {
    if (componentName === 'gender') {
      prac[componentName] = detail.data.value[componentName].value;
    } else {
      if (!prac[componentName] || componentName !== 'telecom') {
        prac[componentName] = [];
      }
      prac[componentName].push(detail.data.value[componentName].value);
      if (componentName === 'telecom') {
        prac[componentName][prac[componentName].length - 1].rank = prac[componentName].length;
      }
    }
    return prac;
  }

  presentRemAler(text: string, subject: string, rank: number) {
    this.alertService.presentDelete(text, subject, () => { this.removeTelecom(rank); });
  }

  removeTelecom(rank: number) {
    this.practitioner.telecom.splice(rank - 1, 1);
    this.practitioner.telecom.map((data, index) => data.rank = index + 1);
    this.callUpdatePractitioner.emit({ practitioner: this.practitioner, componentName: null });
  }
}
